var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_vm._l((_vm.items),function(item,index){return _c(_vm.resolveNavItemComponent(item),{key:index,tag:"component",attrs:{"item":item}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }